import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierItemsController.php
* @route '/api/dossier/{dossier}/items'
*/
const GetDossierItemsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierItemsController.url(args, options),
    method: 'get',
})

GetDossierItemsController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierItemsController.php
* @route '/api/dossier/{dossier}/items'
*/
GetDossierItemsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierItemsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierItemsController.php
* @route '/api/dossier/{dossier}/items'
*/
GetDossierItemsController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierItemsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierItemsController.php
* @route '/api/dossier/{dossier}/items'
*/
GetDossierItemsController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierItemsController.url(args, options),
    method: 'head',
})

export default GetDossierItemsController